import PhotoGallery from '../../PhotoGallery';
import ThermalStrip from '../../thermal/ThermalStrip';
import { canDo } from '../stages';
import * as S from '../../specimens/styles';

/*
 * Photos: every photograph of the isolate -- from the field, the intake and
 * the lab -- in the app's gallery, each labelled with the record it was
 * taken of. Below them, for lab readers, the Thermal strip: the thermal
 * captures linked to the isolate's records, which are not photographs
 * (components/thermal/ThermalStrip.js).
 */
export default function PhotosTab({ item, dossier, user, t, onAction }) {
  const photos = dossier.photos || [];
  // A lab photo is of a plate on the bench: one awaiting creation is not yet.
  const made = (dossier.plates || []).filter((p) => p.status !== 'awaiting_creation');
  return (
    <div>
      {made.length > 0 && canDo(user, 'labPhoto', item) && (
        <div className="hub-tab-actions">
          <button type="button" style={S.ghostBtn} onClick={() => onAction('labPhoto', item)}
            title={t('tip.action.labPhoto')}>{t('action.labPhoto')}</button>
        </div>
      )}
      {photos.length === 0
        ? <p style={S.hint}>{t('details.noPhotos')}</p>
        : <PhotoGallery photos={photos} thumbWidth={96} thumbHeight={72} testId={`hub-photos-${item.specimen_id}`} />}
      <ThermalStrip item={item} dossier={dossier} user={user} />
    </div>
  );
}
